// simplify symbols like 'pl-PL' to simple 'pl'
export function simplifyLanguageSymbol(symbol: string) {
    return symbol.includes("pl") ? 'pl' : 'en'
}